import { gsap } from 'gsap';

export function fadeIn(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // force opacity to 0
        targetEl.style.opacity = 0
        // tween to opacity 1
        gsap.to(targetEl, {
            display: 'block',
            opacity: 1,
            duration: 0.35,
            onComplete: resolve
        })
    })
}

export function fadeOut(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // tween to opacity 0
        gsap.to(targetEl, {
            opacity: 0,
            duration: 0.35,
            onComplete: () => {
                targetEl.style.display = "none";
                resolve();
            }
        })
    });
}